import { Component, Prop, Listen, Element, h } from '@stencil/core';

/**
 * Accordions are a simple wrapper for a group of som-accordion components
 */
@Component({
  tag: 'som-accordion-group',
  styleUrl: 'som-accordion-group.scss',
  shadow: true,
})
export class SomAccordionGroup {
  @Element() el: HTMLElement;

  /**
   * This boolean adds or removes the border for the accordion group.
   */
  @Prop() borders: boolean = false;

  /**
   * This boolean determines if multiple accordions can be open at the same time.
   */
  @Prop() singleOpen: boolean = true;

  // Listen for when an accordion toggles state and determine if other accordions need to close.
  @Listen('accordionToggled', { target: 'body' })
  accordionToggleHandle(e: UIEvent) {
    const accordions: any[] = Array.from(this.el.children);
    for (let accordion of accordions) {

      // This accordion is not the one that triggered the event, is already expanded, and the single open prop is set to true
      if (e.target !== accordion && !accordion.collapsed && this.singleOpen) {
        accordion.hide();
      }
    }
  }

  render() {
    return (
      <div class={this.borders ? 'accordions' : ''}>
        <slot></slot>
      </div>
    );
  }
}
